'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    IconToggleButton: ()=>IconToggleButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_IconToggleButton_variants_cjs_namespaceObject = require("./IconToggleButton.variants.cjs");
const external_react_namespaceObject = require("react");
const react_namespaceObject = require("motion/react");
const HEART_FILL = 'M12 20.325C11.7667 20.325 11.5292 20.2833 11.2875 20.2C11.0458 20.1167 10.8333 19.9833 10.65 19.8L8.925 18.225C7.15833 16.6083 5.5625 15.0042 4.1375 13.4125C2.7125 11.8208 2 10.0667 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.38333 2.64999 9.21667 2.83749 10 3.21249C10.7833 3.58749 11.45 4.09999 12 4.74999C12.55 4.09999 13.2167 3.58749 14 3.21249C14.7833 2.83749 15.6167 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 10.0667 21.2917 11.825 19.875 13.425C18.4583 15.025 16.85 16.6333 15.05 18.25L13.35 19.8C13.1667 19.9833 12.9542 20.1167 12.7125 20.2C12.4708 20.2833 12.2333 20.325 12 20.325Z';
const HEART_OUTLINE = 'M12 20.325C11.7667 20.325 11.5292 20.2833 11.2875 20.2C11.0458 20.1167 10.8333 19.9833 10.65 19.8L8.925 18.225C7.15833 16.6083 5.5625 15.0042 4.1375 13.4125C2.7125 11.8208 2 10.0667 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.38333 2.64999 9.21667 2.83749 10 3.21249C10.7833 3.58749 11.45 4.09999 12 4.74999C12.55 4.09999 13.2167 3.58749 14 3.21249C14.7833 2.83749 15.6167 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 10.0667 21.2917 11.825 19.875 13.425C18.4583 15.025 16.85 16.6333 15.05 18.25L13.35 19.8C13.1667 19.9833 12.9542 20.1167 12.7125 20.2C12.4708 20.2833 12.2333 20.325 12 20.325ZM11.05 6.74999C10.5667 6.06666 10.05 5.54583 9.5 5.18749C8.95 4.82916 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 9.01666 4.30833 9.93749 4.925 10.9125C5.54167 11.8875 6.27917 12.8333 7.1375 13.75C7.99583 14.6667 8.87917 15.525 9.7875 16.325C10.6958 17.125 11.4333 17.7833 12 18.3C12.5667 17.7833 13.3042 17.125 14.2125 16.325C15.1208 15.525 16.0042 14.6667 16.8625 13.75C17.7208 12.8333 18.4583 11.8875 19.075 10.9125C19.6917 9.93749 20 9.01666 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 15.05 4.82916 14.5 5.18749C13.95 5.54583 13.4333 6.06666 12.95 6.74999C12.8333 6.91666 12.6917 7.04166 12.525 7.12499C12.3583 7.20833 12.1833 7.24999 12 7.24999C11.8167 7.24999 11.6417 7.20833 11.475 7.12499C11.3083 7.04166 11.1667 6.91666 11.05 6.74999Z';
function IconToggleButton({ disabled = false, onToggle, size = '32', ariaLabel = 'favorite', isAnimated = false, ...props }) {
    const [onHover, setOnHover] = (0, external_react_namespaceObject.useState)(false);
    const [isToggledOn, setIsToggledOn] = (0, external_react_namespaceObject.useState)(false);
    const shouldReduceMotion = (0, react_namespaceObject.useReducedMotion)();
    const { iconBorderSlot, iconFillSlot } = (0, external_IconToggleButton_variants_cjs_namespaceObject.iconToggleButtonVariants)({
        ...props,
        disabled,
        onHover,
        isToggledOn
    });
    const iconFillSlotClass = iconFillSlot();
    const handleClick = (event)=>{
        setIsToggledOn((prev)=>{
            if (onToggle) onToggle(!prev, event);
            return !prev;
        });
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("button", {
        type: "button",
        onClick: handleClick,
        disabled: disabled,
        "aria-pressed": isToggledOn,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(react_namespaceObject.motion.svg, {
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            overflow: "visible",
            children: [
                isToggledOn && isAnimated && !shouldReduceMotion && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                            d: HEART_FILL,
                            className: (0, index_cjs_namespaceObject.cn)(iconFillSlotClass),
                            initial: {
                                opacity: 1,
                                scale: 0.5,
                                rotate: 45
                            },
                            animate: {
                                opacity: 0,
                                scale: 0.5,
                                x: 15,
                                y: -15,
                                rotate: 45
                            },
                            transition: {
                                duration: 0.5
                            }
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                            d: HEART_FILL,
                            className: (0, index_cjs_namespaceObject.cn)(iconFillSlotClass),
                            initial: {
                                opacity: 1,
                                scale: 0.5,
                                rotate: -45
                            },
                            animate: {
                                opacity: 0,
                                scale: 0.5,
                                x: -15,
                                y: -15,
                                rotate: -45
                            },
                            transition: {
                                duration: 0.5
                            }
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                            d: HEART_FILL,
                            className: (0, index_cjs_namespaceObject.cn)(iconFillSlotClass),
                            initial: {
                                opacity: 1,
                                scale: 0.2
                            },
                            animate: {
                                opacity: 0,
                                scale: 0.2,
                                y: 15
                            },
                            transition: {
                                duration: 0.5
                            }
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                            d: HEART_FILL,
                            className: (0, index_cjs_namespaceObject.cn)(iconFillSlotClass),
                            initial: {
                                opacity: 1,
                                scale: 0.2
                            },
                            animate: {
                                opacity: 0,
                                scale: 0.2,
                                x: 15,
                                y: 5
                            },
                            transition: {
                                duration: 0.5
                            }
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                            d: HEART_FILL,
                            className: (0, index_cjs_namespaceObject.cn)(iconFillSlotClass),
                            initial: {
                                opacity: 1,
                                scale: 0.2
                            },
                            animate: {
                                opacity: 0,
                                scale: 0.2,
                                x: -15,
                                y: 5
                            },
                            transition: {
                                duration: 0.5
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                    d: HEART_FILL,
                    transform: "translate(12, 12) scale(0.9) translate(-12, -12)",
                    onMouseEnter: ()=>setOnHover(true),
                    onMouseLeave: ()=>setOnHover(false),
                    className: (0, index_cjs_namespaceObject.cn)(iconFillSlotClass)
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                    d: HEART_OUTLINE,
                    className: (0, index_cjs_namespaceObject.cn)(iconBorderSlot()),
                    onMouseEnter: ()=>setOnHover(true),
                    onMouseLeave: ()=>setOnHover(false)
                })
            ]
        })
    });
}
exports.IconToggleButton = __webpack_exports__.IconToggleButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "IconToggleButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
